import React, { useCallback } from 'react';
import { failureReasonsTreeData } from 'service/service';
import ComputeHierarchyBase, { FetchServiceParams } from './ComputeHierarchyBase';

const PRESERVE_FILTER_KEY = 'failure_reasons_filters';

const FailureReason = () => {
    const serviceFunc = useCallback((params: FetchServiceParams) => {
        return failureReasonsTreeData({
            startDate: params.startDate,
            endDate: params.endDate,
            env: params.env !== 'both' ? params.env : '',
            sector: params.sector !== 'all' ? params.sector : '',
            location: params.location !== 'ALL' ? params.location : '',
            selectedDateInString: params.apiDateRangeKey,
            page: params.page,
            limit: params.pageSize,
            filters: params.filters,
        });
    }, []);

    return (
        <ComputeHierarchyBase
            serviceFunc={serviceFunc}
            pageTitle="Failure Reasons"
            tableTitlePrefix="Total Distinct Run Count"
            columnLabel="Distinct Run Count"
            isCurrency={false}
            preserveFilterKey={PRESERVE_FILTER_KEY}
            detailPath="/databricksADB/FailureReasonsTable"
            tableType="failure-reasons-table"
            breadcrumbLabel="Job Analysis"
            breadcrumbPath="/databricksADB/jobsADB"
        />
    );
};

export default FailureReason;
